import React, { useState, useEffect } from 'react'
import { withFirebase } from '../firebase';
import Loader from 'react-loader-spinner';
import FileUploader from 'react-firebase-file-uploader';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';


const TeamGeneral = (props) => {

    const { tournament_uid, team_uid } = useParams(); // tournament and team uid
    const userId = props.firebase.auth.currentUser.uid; // user auth uid

    const { loading, team } = props;
    const [uploadingLogo, setUploadingLogo] = useState(false);
    const [saving, setSaving] = useState(false);
    const [title, setTitle] = useState((team && team.title) || '')
    const [contact, setContact] = useState((team && team.contact) || '')
    const [comment, setComment] = useState((team && team.comment) || '')

    useEffect(() => {
        resetTeamValues();
    }, [team])

    const resetTeamValues = (e) => {
        e && e.preventDefault();
        setTitle((team && team.title) || '')
        setContact((team && team.contact) || '')
        setComment((team && team.comment) || '')
    }

    const handleUploadStart = () => {
        setUploadingLogo(true)
    }

    const handleUploadError = (error) => {
        setUploadingLogo(false)
        props.showModal("Error", "Los sentimos, ocurrió un error al subir el archivo.");
    };

    const handleUploadSuccess = filename => {

        props.firebase.file('teams', filename).getDownloadURL()
            .then(fileUrl => {
                team.logoUrl = fileUrl
                setUploadingLogo(false)

                props.firebase.teamDoc(userId, tournament_uid, team_uid).update({
                    logoUrl: fileUrl
                }).catch((error) => {
                    setUploadingLogo(false)
                    console.log("Error: ", error);
                    props.showModal("Error", "Los sentimos, ocurrió un error al subir el archivo.");
                });
            });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const invalid = title === '';
        if (!invalid && !saving) {
            setSaving(true);

            props.firebase.teamDoc(userId, tournament_uid, team_uid).update({
                title: title,
                contact: contact,
                comment: comment
            })
                .then((result) => {
                    setSaving(false);
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    setSaving(false);
                    props.showModal("Error", "No se pudo crear el Equipo");
                });
        }
    }

    const fileName = team.title + "_" + team.uid;
    const filesRef = props.firebase.folder('teams');
    const teamLogo = (team && team.logoUrl) ? team.logoUrl : process.env.PUBLIC_URL + "/team_logo.png"

    if (loading)
        return <div />

    const invalid = title === '';

    return (

        <div className="row  justify-content-center m-0 p-0">
            <div className="col-12 col-md-auto align-self-center row justify-content-center justify-content-md-end m-0 p-0" >
                <div style={{ width: 100, height: 100 }} >
                    {(!uploadingLogo) ?
                        <label className="btn btn-sm m-0 p-0 border-0" >
                            <div className="position-relative" >
                                <div style={{
                                    backgroundImage: `url(${teamLogo})`,
                                    height: 100,
                                    width: 100,
                                    minWidth: 100,
                                    backgroundPosition: 'center',
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat'

                                }} />
                                <span className=" bg-app-transparent rounded-lg p-1 small text-white position-absolute bottom-right">
                                    <FontAwesomeIcon className="mr-1" size="sm" icon={faPen} />
                                        Editar
                                    </span>
                            </div>
                            <FileUploader
                                hidden
                                accept="image/*"
                                name="file"
                                filename={fileName}
                                storageRef={filesRef}
                                onUploadStart={handleUploadStart}
                                onUploadError={handleUploadError}
                                onUploadSuccess={handleUploadSuccess}
                            />
                        </label>
                        :
                        <Loader className="m-2"
                            type="ThreeDots"
                            color="#263238"
                            height={80}
                            width={60}
                            timeout={0} />
                    }
                </div>
            </div>

            <div className="bg-bluegray ml-3 mr-3 d-none d-md-block" style={{ width: 1 }} />

            <div className="col-12 col-md-6 row justify-content-center justify-content-md-start m-0 p-0 mt-2 mt-md-0 " >
                <form className="row m-0 p-0" onSubmit={onSubmit}>
                    <div className="col-12 p-1">
                        <label className="small text-secondary mb-0 ml-1" htmlFor="title">Nombre:</label>
                        <input className="form-control form-control-sm text-dark" value={title || ''} type="text"
                            onChange={(e) => setTitle(e.target.value)} id="title" placeholder="nombre del equipo" autoComplete='off' />
                    </div>

                    <div className="col-12 p-1">
                        <label className="small text-secondary mb-0 ml-1" htmlFor="contact">Contacto:</label>
                        <input className="form-control form-control-sm text-dark" value={contact || ''} type="text"
                            onChange={(e) => setContact(e.target.value)} id="contact" placeholder="teléfono o correo" autoComplete='off' />
                    </div>

                    <div className="col-12 p-1">
                        <label className="small text-secondary mb-0 ml-1" htmlFor="comment">Detalles:</label>
                        <textarea className="form-control form-control-sm text-dark" value={comment || ''}
                            onChange={(e) => setComment(e.target.value)} id="comment" rows="3" placeholder="información general" autoComplete='off' />
                    </div>

                    {(!saving) ?

                        <div className="col-12 d-flex flex-row-reverse p-0 mt-2 ">
                            <button disabled={invalid} type="submit" className="btn btn-sm btn-success m-1">Guardar</button>
                            <button onClick={resetTeamValues} className="btn btn-sm btn-secondary m-1">Cancelar</button>
                        </div>
                        :
                        <div className="col-12 d-flex flex-row-reverse p-0 mt-2">
                            <Loader className="m-0"
                                type="ThreeDots"
                                color="#263238"
                                height={39}
                                width={50}
                                timeout={0} />
                        </div>
                    }
                </form>
            </div>
        </div >
    )

}

export default withFirebase(TeamGeneral)


